<div class="form-block block-blue amb-10" *ngIf="mode == elementMode.Definition">
  <div class="header">
    <span><i class="far fa-file-alt"></i>{{ translationManager.getTranslation('Поље') }} - {{ translationManager.getTranslation('Прилагање документа') }}</span>
    <div class="actions" *ngIf="state == viewState.Create || state == viewState.Edit">
      <div>
        <a href="javascript:;" [title]="translationManager.getTranslation('Обриши елемент')" (click)="delete()"><i class="far fa-trash-alt tc-red"></i></a>
      </div>
    </div>
    <div class="element-orders">
      <div>
                <span>
                    <span class="element-order">
                        <a href="javascript:;" *ngIf="showOrderUp" [title]="translationManager.getTranslation('Промени редослед елементу на горе')" (click)="_element?.onElementOrder && _element?.onElementOrder(_element, elementOrderDirection.Up)"><i class="fa-solid fa-angle-up"></i></a>
                    </span>
                    <span class="element-order">
                        <a href="javascript:;" *ngIf="showOrderDown" [title]="translationManager.getTranslation('Промени редослед елементу на доле')" (click)="_element?.onElementOrder && _element?.onElementOrder(_element, elementOrderDirection.Down)"><i class="fa-solid fa-angle-down"></i></a>
                    </span>
                </span>
      </div>
    </div>
  </div>
  <div class="content">
    <div class="form-element"
         [ngClass]="{ 'error': form.elements['name'].error.required || form.elements['name'].error.invalid }">
      <label>{{ translationManager.getTranslation('Назив') }}</label>
      <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">
        <input type="text" [(ngModel)]="form.elements['name'].value" maxlength="100">
      </div>
      <div class="content" *ngIf="state === viewState.Details">
        <div class="static">
          <span>{{ form.elements['name'].value | appvalue }}</span>
        </div>
      </div>
      <div class="errors">
                <span *ngIf="form.elements['name'].error.required">
                    <i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}</span>
      </div>
    </div>
    <div class="form-element">
      <label><input type="checkbox" [(ngModel)]="form.elements['isMandatory'].value" [disabled]="state == viewState.Details"> {{ translationManager.getTranslation('Да ли је поље обавезно за унос (Да/Не)') }}</label>
    </div>
    <div class="form-element"
         [ngClass]="{ 'error': form.elements['description'].error.required || form.elements['description'].error.invalid }">
      <label>{{ translationManager.getTranslation('Опис') }}</label>
      <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">
        <textarea [(ngModel)]="form.elements['description'].value"></textarea>
      </div>
      <div class="content" *ngIf="state === viewState.Details">
        <div class="static">
          <span>{{ form.elements['description'].value | appvalue }}</span>
        </div>
      </div>
      <div class="errors">
                <span *ngIf="form.elements['description'].error.required">
                    <i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос') }}</span>
      </div>
    </div>
    <div class="form-element">
      <label><input type="checkbox" [(ngModel)]="form.elements['isDocumentMandatory'].value" [disabled]="state == viewState.Details"> {{ translationManager.getTranslation('Да ли је прилагање документа обавезно (Да/Не)') }}</label>
    </div>
  </div>
</div>
<div *ngIf="mode == elementMode.Execution">
  <div class="form-element"
       [ngClass]="{ 'error': formValue.elements['value'].error.required || formValue.elements['value'].error.invalid }">
    <label>{{ form.elements['name'].value }}</label>
    <div class="content" *ngIf="state === viewState.Create || state === viewState.Edit">
      <input type="date" [(ngModel)]="formValue.elements['value'].value">
    </div>
    <div class="content" *ngIf="state === viewState.Details">
      <div class="static">
        <span>{{ formValue.elements['value'].value | appvalue }}</span>
      </div>
    </div>
    <div class="errors">
            <span *ngIf="formValue.elements['value'].error.required">
                <i class="fas fa-times-circle"></i>{{ translationManager.getTranslation('Поље је обавезно за унос')
              }}</span>
    </div>
  </div>
</div>
